import type { Order } from "@/redux/services/order/order.type";

/**
 * Cents still owed back to the customer on an overpaid order.
 *
 * The API's `remainingAmount` is already net of refunds
 * (`Order::getRemainingAmount()` = total − paid + refunded), so the amount
 * still to refund is simply its negative part. Subtracting `refundedAmount`
 * again would count every refund twice (SFRESTO-114).
 */
export const getOutstandingRefund = (
  order: Pick<Order, "remainingAmount" | "refundedAmount">,
): number => Math.max(0, -(order.remainingAmount ?? 0));
